import { render, staticRenderFns } from "./ReviewNotifyModal.vue?vue&type=template&id=9153e82a&scoped=true&"
import script from "./ReviewNotifyModal.vue?vue&type=script&lang=js&"
export * from "./ReviewNotifyModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewNotifyModal.vue?vue&type=style&index=0&id=9153e82a&lang=scss&scoped=true&"
import style1 from "./ReviewNotifyModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153e82a",
  null
  
)

export default component.exports